import {
  Grid,
  Box,
  Typography,
  List,
  SwipeableDrawer,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { NotificationIcon, CrossIcon } from '../../theme/styled-components';
import NotificationListItem from '../notification-listitem/component';
import NotificationBadge from '../notification-badge/container';
import { Notification } from '../../types/notification';
import styles from './styles';

interface Props {
  classes?: Record<string, string>;
  handleOpenNotificationDrawer?: (
    e: React.SyntheticEvent<object>,
    open: boolean,
  ) => void;
  notificationdraweropen?: boolean;
  notifications?: { items: Notification[] };
  openingNotification?: (...args: unknown[]) => void;
}

function NotificationDrawer({
  classes = {},
  handleOpenNotificationDrawer = () => {},
  notificationdraweropen = false,
  notifications = { items: [] },
  openingNotification = () => {},
}: Props) {
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper,
      }}
      data-testid="notification-drawer"
      disableSwipeToOpen
      anchor="right"
      open={notificationdraweropen}
      onClose={(e) => handleOpenNotificationDrawer(e, false)}
      onOpen={() => {}}
    >
      <Box m={4}>
        <Grid container justifyContent="space-between">
          <Box className={classes.notificationIconContainer}>
            <NotificationIcon />
            <NotificationBadge />
          </Box>
          <Grid item xs={1}>
            <CrossIcon
              onClick={(e) => handleOpenNotificationDrawer(e, false)}
              className={classes.notificationClose}
              data-testid="notification-drawer-close"
            />
          </Grid>
        </Grid>
        <Box my={4}>
          <Typography
            className={classes.notificationTitle}
            data-testid="notification-drawer-title"
            variant="h1"
          >
            Notifications
          </Typography>
        </Box>
        <Box>
          <List
            className={classes.notificationsMenu}
            data-testid="notification-drawer-list"
          >
            {notifications.items.length === 0 && (
              <Box my={1}>
                <Typography className={classes.notificationsText} variant="h3">
                  You have no notifications{' '}
                </Typography>
              </Box>
            )}
            {notifications.items &&
              notifications.items.map((notification) => (
                <NotificationListItem
                  key={notification.id}
                  notification={notification}
                  openingNotification={openingNotification}
                />
              ))}
          </List>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

// @ts-expect-error — pre-existing type mismatch from JS theme files (custom palette/typography properties)
export default withStyles(styles)(NotificationDrawer);
